export enum KnmPlanListFilterActionsEnum {
  PLAN_LIST_FILTER_SET_LOADING = 'PLAN_LIST_FILTER_SET_LOADING',
  PLAN_LIST_FILTER_SET_SWITCHER = 'PLAN_LIST_FILTER_SET_SWITCHER',
  PLAN_LIST_FILTER_SET_CURRENT = 'PLAN_LIST_FILTER_SET_CURRENT',
  PLAN_LIST_FILTER_GET_META = 'PLAN_LIST_FILTER_GET_META',
  PLAN_LIST_FILTER_SET_META = 'PLAN_LIST_FILTER_SET_META',
  PLAN_LIST_FILTER_GET_DATA = 'PLAN_LIST_FILTER_GET_DATA',
  PLAN_LIST_FILTER_SET_DATA = 'PLAN_LIST_FILTER_SET_DATA',
  PLAN_LIST_FILTER_CREATE = 'PLAN_LIST_FILTER_CREATE',
  PLAN_LIST_FILTER_UPDATE = 'PLAN_LIST_FILTER_UPDATE',
  PLAN_LIST_FILTER_REMOVE = 'PLAN_LIST_FILTER_REMOVE',
  PLAN_LIST_GET_SUPERVISION_TYPES = 'PLAN_LIST_GET_SUPERVISION_TYPES',
  DICTIONARIES_SUPERVISION_TYPE_ITEM_GET_SUCCESS = 'DICTIONARIES_SUPERVISION_TYPE_ITEM_GET_SUCCESS',
}
